import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchInvoices = (filters) => {
  const invoice = filters.invoice ? `&invoice=${filters.invoice}` : '';
  const providerId = filters.providerId ? `&providerId=${filters.providerId}` : '';
  const dealerId = filters.dealerId ? `&dealerId=${filters.dealerId}` : '';
  const status = filters.status ? `&status=${filters.status}` : '';
  const startDate = filters.startDate ? `&startDate=${filters.startDate}` : '';
  const endDate = filters.endDate ? `&endDate=${filters.endDate}` : '';

  const allFilters = `${invoice}${providerId}${dealerId}${status}${startDate}${endDate}`;

  return apiActionCreator({
    'endpoint': `/invoices/imports?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_INVOICES,
      ActionTypes.FETCHED_INVOICES,
      [
        ActionTypes.FETCHED_INVOICES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const generateOrderNote = (invoice) => apiActionCreator({
  'endpoint': `/invoices/imports/order-note/${invoice}`,
  'authenticated': true,
  'types': [
    ActionTypes.GENERATE_ORDER_NOTE_REQUEST,
    ActionTypes.GENERATE_ORDER_NOTE_SUCCESS,
    [
      ActionTypes.GENERATE_ORDER_NOTE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearOrderNoteUrl = () => ({
  'type': ActionTypes.CLEAR_ODER_NOTE_URL,
});

export const clearInvoicesData = () => ({
  'type': ActionTypes.CLEAR_INVOICES_DATA,
});

export const changeInvoicesListPage = (value) => ({
  'type': ActionTypes.CHANGE_INVOICES_LIST_PAGE,
  'payload': value,
});

export const changeInvoicesListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_INVOICES_LIST_PAGE_SIZE,
  'payload': value,
});
